import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  editandRemove: {
    fontFamily: "Lato",
    fontStyle: "normal",
    fontSize: theme.typography.pxToRem(16),
    lineHeight: "24px",
    color: "#0F172A",
  },
  titlePicture: {
    paddingBottom: "20px",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "24px",
    color: "#0F172A",
    paddingLeft: "100px",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "0px",
    },
  },
  fileWrapper: {
    textAlign: "left",
    margin: "8px",
    width: "100%",
    height: 300,
    position: "relative",
  },
  fileWrapperModal: {
    height: "137px !important",
  },
  fileWrapperNewParticipant: {
    [theme.breakpoints.down("sm")]: {
      display: "inline-block",
      textAlign: "center",
      width: "auto",
    },
  },
  fileContainerNewParticipant: {
    border: "dashed 1px #D1D4DE !important",
  },
  fileContainer: {
    height: "100%",
    width: "100%",
    position: "relative",
    border: "dashed 4px #76838f",
    borderRadius: 1,
    borderColor: "#76838f",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  fileWrapperRounded: {
    width: 300,
    height: 300,
    borderRadius: "50%",
  },
  fileInput: {
    position: "absolute",
    opacity: "0%",
    width: "100%",
    height: "100%",
    cursor: "pointer",
    display: "none",
  },
  imageOverlay: {
    position: "absolute",
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.3)",
    zIndex: 40,
  },
  errorMessage: {
    color: "#CF1B1B !important",
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "17px",
  },
  changeImageNewParticipants: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "14px",
    backgroundColor: "#F1F5FF !important",
    color: "#0344DC !important",
    width: "105px !important",
    height: "17px !important",
    borderRadius: "100px !important",
  },
  imageOverlayNewParticipants: {
    backgroundColor: "#FFFFFF",
  },
  uploadImageButton: {
    backgroundColor: "#F1F5FF !important",
    color: "#0344DC !important",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "14px",
    width: "124px !important",
    height: "33px !important",
    borderRadius: "100px !important",
  },
  cancelButton: {
    backgroundColor: "#FFFFFF !important",
    borderColor: "#FFFFFF",
    color: "#0344DC !important",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "14px",
    width: "33px !important",
    height: "17px !important",
    borderRadius: "6px !important",
  },
  updateBottom: {
    background: "#0344DC !important",
    borderRadius: "100px",
    color: "#FFFFFF !important",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "14px",
    width: "48px !important",
  },
  dialogAction: {
    justifyContent: "flex-end !important",
  },
  fileButton: {
    borderRadius: 4,
    padding: "4px  22px 7px 20px",
    color: "#76838f",
    zIndex: 50,
    cursor: "pointer",
    transition: ".2s all ease-in-out",
    outline: "none",
    border: "none",
    "&:hover": {
      backgroundColor: "#ced2d4",
      color: "#76838f",
    },
  },
  imageCropResult: {
    width: 300,
    height: 300,
    borderRadius: "50%",
    zIndex: 40,
    overflow: "hidden",
    marginLeft: "auto",
    marginRight: "auto",
  },
  fileButtonEdit: () => ({
    padding: 0,
    zIndex: 50,
    cursor: "pointer",
    transition: ".2s all ease-in-out",
    outline: "none",
    border: "none",
    position: "absolute",
    minWidth: 0,
    width: 44,
    height: 44,
    borderRadius: "50%",
    bottom: 16,
    right: 16,
    "& .MuiIconButton-root": {
      padding: 0,
      color: "white !important",
    },
  }),
  fileButtonEditNewParticipants: {
    backgroundColor: "#E6F1FF !important",
    color: "#000000 !important",
  },
  cropImageContainer: {
    width: "100%",
    height: 350,
    position: "relative",
  },
  avatar: {
    position: "absolute",
    left: -2,
    top: -2,
    width: 296,
    height: 296,
    borderRadius: "50%",
    overflow: "hidden",
  },
  fileButtonContainer: {
    marginTop: theme.spacing(1),
  },
  changeFileButton: {
    backgroundColor: "#e4eaec",
    borderRadius: 4,
    padding: "4px  22px 7px 20px",
    color: "#76838f",
    zIndex: 50,
    cursor: "pointer",
    transition: ".2s all ease-in-out",
    outline: "none",
    border: "none",
    "&:hover": {
      backgroundColor: "#ced2d4",
      color: "#76838f",
    },
  },
}));
